import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { toast } from "sonner";
import { ujmsPendingDocket, ujmsCertifyDocket } from "../../services/ujmsApi";
import { Panel, thCls, tdCls, fmtDT, btnPrimary, EmptyState } from "../ui";
import { ScrollText } from "lucide-react";

export default function DocketQueue() {
  const [rows, setRows] = useState([]);
  const load = () => ujmsPendingDocket().then((r) => setRows(r.data)).catch(() => {});
  useEffect(() => { load(); }, []);

  const certify = async (e) => {
    try {
      await ujmsCertifyDocket(e.case_id, e.id);
      toast.success(`Docket #${e.sequence_number} certified`);
      load();
    } catch (err) { toast.error(err.response?.data?.detail || "Certification failed"); }
  };

  return (
    <div className="space-y-4" data-testid="docket-queue">
      <div>
        <h1 className="text-2xl font-semibold tracking-tight text-slate-900">Docket Queue</h1>
        <p className="text-sm text-slate-500">Manual docket entries awaiting certification. Certified entries are immutable — corrections create new referencing entries.</p>
      </div>
      <Panel testId="docket-queue-panel">
        {rows.length === 0 ? (
          <EmptyState icon={ScrollText} title="No docket entries awaiting certification" note="Manual clerk entries appear here until certified." testId="docket-queue-empty" />
        ) : (
          <table className="w-full border-collapse">
            <thead><tr>
              <th className={thCls}>Entered</th><th className={thCls}>Case</th><th className={thCls}>Seq</th>
              <th className={thCls}>Code</th><th className={thCls}>Description</th><th className={thCls}>Entered By</th><th className={thCls}>Action</th>
            </tr></thead>
            <tbody>
              {rows.map((e) => (
                <tr key={e.id} className="hover:bg-slate-50">
                  <td className={`${tdCls} font-mono text-xs whitespace-nowrap`}>{fmtDT(e.created_at)}</td>
                  <td className={`${tdCls} font-mono text-xs`}>
                    <Link to={`/ujms/cases/${e.case_id}`} className="text-blue-900 hover:underline">{e.case_number}</Link>
                    <div className="text-slate-400 truncate max-w-[180px]">{e.caption}</div>
                  </td>
                  <td className={`${tdCls} font-mono text-xs`}>#{e.sequence_number}</td>
                  <td className={`${tdCls} font-mono text-xs`}>{e.event_code}</td>
                  <td className={tdCls}><span className="line-clamp-2 max-w-[320px]">{e.description}</span></td>
                  <td className={`${tdCls} text-xs`}>{e.entered_by}</td>
                  <td className={tdCls}>
                    <button className={btnPrimary} onClick={() => certify(e)} data-testid={`docket-certify-${e.id}`}>Certify</button>
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        )}
      </Panel>
    </div>
  );
}
